module.exports = "data:image/gif;base64,R0lGODlhCgAKALMAANfX16Ojo////+Dg4Onp6ebm5tra2uXl5efn5+Li4gAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAKAAoAAAQhEEgwQiiETCDsQdokCENyFJthVcHWBa8rGOOw3Xiu70AEADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/sizer/sw-handle.gif
 ** module id = 497
 ** module chunks = 0
 **/